import { LocationStrategy } from '@angular/common';
import { IsGuid } from '@asamco/utils';
import { MenuItem } from '../menu/menu-item.interface';
import { IFrameMessages, MessageType } from './message-type.enum';

function fixUrls(appOid: string, menuItem: MenuItem) {
	if (menuItem.url) {
		if (!menuItem.url.includes('remote-app')) {
			menuItem.url = menuItem.url.replace('legacy/#!/', '#!/remote-app/');

			if (!menuItem.url.includes('remote-app')) {
				menuItem.url = menuItem.url.replace('#!/', '#!/remote-app/');
			}
		}
		menuItem.url = menuItem.url.replace('/remote-app/', `/remote-app/${appOid}/`);
	}

	if (menuItem.children) {
		menuItem.children.forEach(c => fixUrls(appOid, c));
	}
}

/**
 * Helper for dealing with implementing AP-1272 properly.
 * We need to support old (and older) applications.
 *
 * @returns appOid guid when found
 */
export function getApplicationOidFromPath(locationStrategy: LocationStrategy): string {
	const path = locationStrategy.path();
	const match = path.match(/^\!\/remote-app\/([^\/?]+)(?:[\/?].*)?$/);
	if (match && match.length === 2 && IsGuid(match[1])) {
		return match[1];
	} else {
		// TODO: What to do?
		throw new Error(`Failing to parse appOid from: ${path}`);
	}
}

/**
 * Attempts to fix the urls of menu items from inner apps.
 * End result should always resemble:
 *
 * ```
 * '/#!/remote-app/<app-oid>/<some-path>'
 * ```
 *
 * where <some-path> is optional.
 *
 * See also: AP-1272
 */
export function fixInnerAppMenuItemMessages(locationStrategy: LocationStrategy, payload: IFrameMessages[MessageType.sideMenu]): void {
	const appOid = getApplicationOidFromPath(locationStrategy);

	if (payload?.payload?.menuItem) {
		fixUrls(appOid, payload.payload.menuItem);
	}
}

export const ignoredWebpackMessageTypes = ['webpackOk', 'webpackClose', 'webpackWarnings', 'webpackInvalid'];
